module.exports = __webpack_public_path__ + "static/media/16th.b8315e0c.png";